import IconDownload from '@dealroadshow/uikit-icon/IconDownload';
import IconFileXls from '@dealroadshow/uikit-icon/IconFileXls';
import { IFaqCollection } from '@framework/ui/Pages/Landing/Sections/Faq/interface';
import styles from './styles.module.scss';

export const faqCollection: IFaqCollection[] = [
  {
    hash: 'what-is-allocate',
    question: 'What is Allocate?',
    answer: (
      <>
        <p>
          Allocate is a business intelligence solution for investor orderbooks, pot lists and final allocations.
        </p>
        <br />
        <p>
          It enables broker-dealers and issuers to extract insights and analyze trends
          from historical investor engagement and buying patterns during a particular new
          issue syndication process or across their entire library of historical transactions.
        </p>
        <br />
        <p>
          Data from Allocate also feeds directly into Investor Targeting on Deal Roadshow,
          which continuously generates a predictive list of investors to target during an
          active new issue marketing process.
        </p>
      </>
    ),
  },
  {
    hash: 'how-does-allocate-work',
    question: 'How do I upload my pot lists to Allocate?',
    answer: (
      <>
        <p>
          Pot lists can be uploaded to Allocate via excel template directly from the FINSIGHT
          Deal Manager Portal or by sending your files in any format to our Fanatical 24x7 support team.
        </p>
        <br />
        <p>
          Once received, our team will revert with an estimated completion timeline based on the number
          of pot lists provided and required clean up. Uploads will commence within 12 hours and we will
          seek clarity as necessary to ensure your pot list data is accurately mapped to FINSIGHT nomenclature.
        </p>
        <br />
        <p>
          Once completed, A FINSIGHT representative will be in touch to schedule
          a 1-on-1 walkthrough of the platform.
        </p>
      </>
    ),
  },
  {
    hash: 'who-gets-access',
    question: 'Who gets access to my pot lists on Allocate?',
    answer: (
      <>
        <p>
          Only the people and organizations you explicitly authorize are able to
          access your pot lists on Allocate.
        </p>
        <br />
        <p>
          By default when a pot list in Allocate is linked to a Deal Roadshow, all Deal Managers on
          the Roadshow will also have access to the linked allocation (usually the lead left
          and/or the issuer on the deal). During the upload process, our team will confirm this
          information with you and will update permissions accordingly.
        </p>
      </>
    ),
  },
  {
    hash: 'how-do-i-export',
    question: 'How do I export my pot lists from Allocate to Excel?',
    answer: (
      <>
        <p>
          Allocate allows Deal Managers to export individual pot lists or aggregated lists
          of pot lists across deals and tranches.
        </p>
        <br />
        <p>
          Export an individual pot list via
          the <IconDownload className={ styles.icon } /> while
          mousing over an allocation on the Allocations page.
        </p>
        <br />
        <p>
          Export an aggregated list of all of your pot lists by tranche
          via the <IconFileXls className={ styles.icon } /> on
          the Allocate “By Tranche” tab of Global Analytics.
        </p>
      </>
    ),
  },
  {
    hash: 'can-i-export',
    question: 'Can I export an aggregated sum of all orders and allocations for a particular investor across all of my uploaded pot lists?',
    answer: (
      <>
        <p>
          Yes! One of the reasons our clients choose Allocate is for the ability to
          instantly filter by date, deal, account type, sector and more, then export those
          results to a clean, aggregated Excel file.
        </p>
        <br />
        <p>
          Export a filtered list of your pot lists for a
          particular investor via the <IconFileXls className={ styles.icon } /> on the Allocate
          “By Account” tab of Global Analytics.
        </p>
      </>
    ),
  },
  {
    hash: 'how-much-does-allocate-cost',
    question: 'How much does Allocate cost?',
    answer: (
      <>
        <p>
          Allocate by FINSIGHT is currently a FREE solution.
        </p>
        <br />
        <p>
          Should we roll out any pricing in the future,
          all Allocate clients will be updated in a timely manner by a FINSIGHT representative.
        </p>
      </>
    ),
  },
  {
    hash: 'how-is-allocate-related',
    question: 'How is Allocate related to FINSIGHT?',
    answer: (
      <>
        <p>
          Allocate is a wholly-owned and operated solution of New York City-based
          Finsight Group Inc (referred throughout as FINSIGHT), our parent company
          and the maker of various industry leading financial technology applications.
        </p>
        <br />
        <p>
          To learn more about Finsight, visit <a href="https://finsight.com/about" target="_blank">www.finsight.com/about</a>.
        </p>
      </>
    ),
  },
];
